import React from 'react';
import ArrowIcon from 'assets/svgs/actions/arrow-drop.svg';

import ActiveIcon from 'assets/svgs/status/published.svg';
import messaages from '../messages';

const Labels = ({selected, isOpen, setIsOpen, className}) => (
  <div className={`actions-btn filter-item ${className || ''}`}>
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        setIsOpen(!isOpen);
      }}
      data-toggle="collapse"
      className={`${
        isOpen ? '' : 'collapsed'
      } text-capitalize d-flex align-items-center justify-content-center`}
      aria-expanded={isOpen}
    >
      {isOpen && <img src={ActiveIcon} className="active-img mr-3" alt="" />}
      {!isOpen && <img src={ActiveIcon} className="deactive-img mr-3" alt="" />}
      {selected ? selected.label : messaages.label}
      <img src={ArrowIcon} className="ml-2" alt="" />
    </button>
  </div>
);

export default Labels;
